// extracted by mini-css-extract-plugin
module.exports = {"text":"components-ResetPasswordApproved-ResetPasswordApproved__text--a0u_n"};